import { Auth } from 'aws-amplify';
import { useCallback, useContext, useEffect } from 'react';
import Avatar from 'react-avatar';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { User } from '../API';
import { Inbox, LogoBug, Logout, Users } from '../assets/icons';
import { Colors } from '../constants';
import UserContext from '../contexts/UserContext';

// const navItems = [
//   {
//     path: '/users',
//     Icon: Users,
//   },
//   {
//     path: '/inboxes',
//     Icon: Inbox,
//   },
// ];

function HeaderMenu(props: { user: User }) {
  return (
    <div className="flex justify-center items-center z-10">
      <Avatar name={`${props?.user?.firstName} ${props?.user?.lastName}`} round size="40" />
    </div>
  );
}

const MainLayout = (props: { loggedIn: boolean | null }) => {
  const navigate = useNavigate();
  const { currentUser, setCurrentUser } = useContext(UserContext);

  useEffect(() => {
    if (currentUser !== undefined && currentUser !== null && !currentUser) {
      navigate('/auth/login');
    }
  }, [currentUser, navigate]);

  const handleLogout = useCallback(async () => {
    await Auth.signOut();
    setCurrentUser(false);
  }, [setCurrentUser]);

  return (
    <>
      {(props?.loggedIn || currentUser) && (
        <div className="h-full flex">
          <aside className="w-1/12 justify-center items-center text-center p-1 max-w-[100px] min-w-[50px] border-r-[1.5px] border-r-lightestGray bg-stone">
            <div className="mb-10 p-1 md:p-3">
              <LogoBug className="inline w-full fill-ginger max-w-[40px]" />
            </div>
            <div className="flex flex-col justify-between">
              {/* {navItems.map((item, k) => (
                <div className="justify-center items-center text-center pt-10" key={k}>
                  <Link to={item.path}>
                    <item.Icon className="inline hover:cursor-pointer max-w-[30px] stroke-charcoal stroke-[1.2px] hover:stroke-ginger hover:shadow-sm" />
                  </Link>
                </div>
              ))} */}
              <div className="absolute bottom-10 p-5">
                <button onClick={handleLogout}>
                  <Logout className="inline hover:cursor-pointer max-w-[30px] stroke-charcoal stroke-[1.2px] hover:stroke-ginger hover:shadow-sm" />
                </button>
              </div>
            </div>
          </aside>
          <article className="w-full h-full shadow-lg">
            <header className="w-full p-8 border-b-2 border-lightestGray bg-white">
              <div className="flex justify-end">{currentUser?.user && <HeaderMenu user={currentUser.user} />}</div>
            </header>
            <section className="bg-white h-screen">
              <Outlet />
            </section>
          </article>
        </div>
      )}
    </>
  );
};

export default MainLayout;
